import { IDate } from "@nju/data-access-portal-appointment";
import { getDaysInMonth } from "./getDaysInMonth";

export function disabledDaysInMonth(
  availableDates: IDate[],
  calendarDate: string,
) {
  if (availableDates.length === 0) {
    return [];
  }

  const firstAvailableSlot = calendarDate;

  const daysFromBE = new Set(
    availableDates.map((day) => {
      return day.date;
    }),
  );

  // return all days in month excluding available days from BE
  return getDaysInMonth(firstAvailableSlot).filter((date) => {
    return !daysFromBE.has(date);
  });
}
